import { api } from './api-client';
import type { Step, FilterGroup, FunnelResult } from '@/types';

type CalculateFunnels = {
  projectId: string;
  steps: Step[];
  startDate: Date;
  endDate: Date;
  filterGroups: FilterGroup[];
};

export const FunnelsService = {
  calculateFunnels: async ({ projectId, steps, startDate, endDate, filterGroups }: CalculateFunnels) => {
    const { data } = await api.post<{ data: FunnelResult }>(`/analytics/funnels`, {
      projectId, steps: steps.filter(Boolean), startDate, endDate, filterGroups,
    });
    return data;
  },
};
